jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupBanner();
	setupBackToTop();
	setupSearchToggle();
	setupFancyFocus();
	setupScrollEvents();
	setupAccordions(); //this is here instead of in the block since an accordion is in the footer
	
}

function setupMobileMenu(){
	
	jQuery('#hamburger').on('click', function(){
		jQuery('html').toggleClass('main-menu-is-open');
	});
	
	jQuery('#main-nav .close').on('click', function(){
		jQuery('html').removeClass('main-menu-is-open');
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupBanner(){
    
    var banner = document.getElementById('global-alert');
    var closeButton = document.getElementById('close-alert');
    var html = document.getElementsByTagName('html')[0];
    
    if(!banner || !closeButton || !html)
    	return false;
    
    //show banner if it hasn't been closed
    var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
    
    console.log(bannerHasBeenClosed);
    
    if(bannerHasBeenClosed) {
    
    	html.classList.remove('enable-global-alert');
    	banner.classList.remove('show');
    
    } else{
     
        banner.classList.add('show');
    
    }
    
    closeButton.addEventListener('click', function(){
        banner.classList.remove('show');
        html.classList.remove('enable-global-alert');
        sessionStorage.setItem('bannerHasBeenClosed', true);
    });
    
}

function setupBackToTop(){
	
	jQuery('#top').on('click', function(){
		jQuery('html, body').animate({scrollTop: 0}, 'slow');
	});
	
}

function setupSearchToggle(){
	
	jQuery('.search-toggle').on('click', function(e){
		
		e.stopPropagation();
		
		jQuery('.search-container form input').focus();
		
		jQuery(this).parent().toggleClass('show-search');
		
	});
	
	jQuery('.search-container form').on('click', function(e){
		e.stopPropagation();
	});
	
	jQuery('html').on('click', function(){
		
		jQuery('.search-container').removeClass('show-search');
		
	});
	
}

function setupAccordions(){
	
	jQuery(".accordion > .row").click(function(){
		
		var currentRow = jQuery(this);
		var parent = currentRow.parents(".accordion");

		currentRow.toggleClass('active');

		jQuery('.description', currentRow).slideToggle(300);
			
	});
	
	jQuery(".accordion > .row a").on('click', function(e){
		e.stopPropagation();
	});
	
}

function setupFancyFocus(){	
	var formElements = jQuery('input, textarea');
	formElements.on('focus', function(){
		jQuery(this).closest("li").addClass('focus');
	});
	formElements.on('blur', function(){
		var listItem = jQuery(this);
		if (!listItem.val()) 
		{
			listItem.closest("li").removeClass('focus');
		}
		
	});
}
function setupScrollEvents()
{
	jQuery(window).on('scroll', function(){
		adjustHeader();
	});
	adjustHeader();
} 
function adjustHeader() 
{
	
	if(jQuery(window).scrollTop() > 100)
	{
		jQuery('html').addClass('not-top');
	}
	else
	{
		jQuery('html').removeClass('not-top');

	}
}

